import React from "react";
import { Label, Input, FormGroup } from "reactstrap";

const TimeInput = ({ label = "Select Time", value, onChange, name }) => {
  return (
    <FormGroup>
      {label && <Label className="text-black">{label}</Label>}
      <Input
        type="time"
        name={name}
        value={value}
        onChange={onChange}
        className="form-control"
        style={{ borderRadius: "12px", border: "1px solid #D0D5DD" }}
      />
    </FormGroup>
  );
};

export default TimeInput;
